/**
 * LifecycleBadge — colored pipeline-status pill. Tolerates unknown/legacy
 * lifecycle values (renders them title-cased on the neutral style).
 */
import { lifecycleMeta } from '../lib';

interface Props {
  status: string | null | undefined;
  className?: string;
}

export default function LifecycleBadge({ status, className = '' }: Props) {
  const meta = lifecycleMeta(status);
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium whitespace-nowrap ${meta.badge} ${className}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${meta.dot}`} />
      {meta.label}
    </span>
  );
}
